import type { PrintTemplateModel } from '@/types/models/PrintTemplateModel'

export type TemplateState = {
    templates: PrintTemplateModel[]
    template?: PrintTemplateModel
}

export enum ETemplateActions {
    FETCH_TEMPLATES = 'fetchTemplates',
    CREATE_TEMPLATE = 'createTemplate',
    UPDATE_TEMPLATE = 'updateTemplate',
    DOWNLOAD_TEMPLATE = 'downloadTemplate',
    DELETE_TEMPLATE = 'deleteTemplate'
}

export enum ETemplateMutations {
    SET_TEMPLATES = 'setTemplates',
    SET_LOADING = 'setLoading',
    SET_PAGINATION = 'setPagination',
    ADD_TEMPLATE = 'addTemplate',
    UPDATE_TEMPLATE = 'updateTemplate',
    REMOVE_TEMPLATE = 'removeTemplate'
}
